import * as React from "react";
import styled from "@emotion/styled";

import LottieWrapper from "../Anim/LottieWrapper";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 20px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

export default () => (
  <Wrapper>
    <LottieWrapper
      width={300}
      height={200}
      loop={true}
      anim={require("../../LottieFiles/loader.json")}
    />
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/Components/Loader/DotLoader.tsx